import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';
import type { UpdateRolePermissionsRequest } from '../types/role';

/**
 * PATCH /api/eraf/roles/{id}/permissions — 역할 Permission 매트릭스 전체 교체
 */
export function useUpdateRolePermissions(id: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateRolePermissionsRequest) =>
      roleApi.updatePermissions(id, body),
    onSuccess: (data) => {
      queryClient.setQueryData(['role-management', 'detail', id], data);
      void queryClient.invalidateQueries({ queryKey: ['role-management', 'list'] });
    },
  });
}
